const etag: any = {
  menu: /etag:.*/,
  tag: 'etag:tag',
  variant: 'etag:variant',
  settings: 'etag:settings'
};

export default etag;